// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"131":"2f009ffe","173":"8bc35168","534":"9eebb549","629":"489858f9"}[chunkId] + ".css";
};